import { render, staticRenderFns } from "./StuScore.vue?vue&type=template&id=6c6cc2ec&scoped=true&"
import script from "./StuScore.vue?vue&type=script&lang=js&"
export * from "./StuScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6cc2ec",
  null
  
)

export default component.exports